import { SectionHeading, ProductCard } from '@/shared/components/SolarSections';
import { products } from '@/shared/utils/SolarData';

const ProductsPage = () => {
  return (
    <div className="px-4 pt-8 pb-16 sm:px-6 lg:px-8 lg:pt-12 lg:pb-24">
      <div className="mx-auto max-w-7xl space-y-12">
        <SectionHeading
          eyebrow="Products"
          title="Solar hardware that supports dependable performance"
          description="We supply and recommend products that fit the project context, budget, and performance goals."
          align="center"
        />

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {products.map((product, index) => (
            <ProductCard key={product.title} {...product} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsPage;